module.exports = __webpack_public_path__ + "media/images/tennis-2-b3464129.jpg";